/**
 * Labstep
 *
 * @module components/Entity/ListCreate/Search
 * @desc Search for an entity into a list create
 */

import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import type { ParamsStateContextType } from 'labstep-web/contexts/params-state/types';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import type { PostFilterNodeType } from 'labstep-web/services/postFilter/constants';
import {
  PostFilterComparison,
  PostFilterOperator,
} from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import type {
  EntityListCreateSearchContainerProps,
  EntityListCreateSearchProps,
} from './types';

export const EntityListCreateSearch: React.FC<
  EntityListCreateSearchProps
> = ({
  entity,
  entityName,
  create,
  onChangeCreateProps,
  toggle,
  extraParams,
}) => {
  const systemFilter: PostFilterNodeType = {
    type: PostFilterOperator.and,
    predicates: [
      {
        value: entity.guid,
        attribute: 'guid',
        comparison: PostFilterComparison.neq,
      },
    ],
  };

  const params = {
    ...extraParams,
  };

  if (params.template_id) {
    systemFilter.predicates!.push({
      value: params.template_id as any,
      attribute: 'template',
      comparison: PostFilterComparison.eq,
    });
    delete params.template_id;
  }
  const paramsStateContext: ParamsStateContextType = {
    globalParams: {
      ...params,
      filter: [
        {
          ...systemFilter,
        },
      ],
    },
    initialSearchParams: systemFilter as Record<string, unknown>,
  };

  return (
    <ParamsStateContextProvider value={paramsStateContext}>
      <SearchSelect
        labelKey="displayName"
        usePostFilter
        autoFocus
        openMenuOnFocus
        params={params}
        entityName={entityName}
        value={null}
        onBlur={toggle}
        onChange={(selectedOption) => {
          const createProps = onChangeCreateProps(selectedOption);
          create(createProps);
          toggle();
        }}
        usePartialSerializer
      />
    </ParamsStateContextProvider>
  );
};

export const EntityListCreateSearchContainer: React.FC<
  EntityListCreateSearchContainerProps
> = ({
  entity,
  createEntityName,
  searchEntityName,
  onChangeCreateProps,
  ...rest
}) => (
  <EntityCreateContainer entityName={createEntityName}>
    {({ create }) => (
      <EntityListCreateSearch
        entity={entity}
        create={create}
        entityName={searchEntityName}
        onChangeCreateProps={onChangeCreateProps}
        {...rest}
      />
    )}
  </EntityCreateContainer>
);
